import { ButtonProps, alpha, styled } from '@mui/material';
import { MouseEvent, PropsWithChildren, ReactElement } from 'react';

import { PoolIconButton } from '../buttons';

export interface QuickActionsProps extends PropsWithChildren, ButtonProps {
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}

const StyledIconButton = styled(PoolIconButton)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.7),
    },
}));

export const PoolQuickActionButton = (props: QuickActionsProps): ReactElement => {
    const { onClick, ...buttonProps } = props;

    return (
        <StyledIconButton onClick={onClick} size="large" color="medium" {...buttonProps}>
            {props.children}
        </StyledIconButton>
    );
};
